import type { Cover as CoverType, Upsell } from "../../../types";
import { Coverage as CoverageUK } from "./CoverageUK";
export type DisplayVariant = "qcp" | "qds";

export type CoverageProps = {
  covers: CoverType[];
  additionalCoverage?: boolean;
  extraCovers?: CoverType[];
  className?: string;
  displayVariant: DisplayVariant;
  withModal?: boolean;
  variant?: string;
  upsells?: Upsell[];
};

export const Coverage = (props: CoverageProps) => {
  return <CoverageUK {...props} />;
};
